import { PropsWithChildren } from 'react'

type Props = {
  condition: boolean | undefined
}

const Optional = ({ children, condition }: PropsWithChildren<Props>) => {
  if (!condition) return null
  return children
}

export default Optional
